// extracted by mini-css-extract-plugin
export default {"images":"ticketMessage_images__nOGqe","image":"ticketMessage_image__VuDyv","single":"ticketMessage_single__MB7gI"};